<script>
import MainContainer from '../Components/UI/Content/MainContainer.vue'
import BlockContent from '../Components/UI/Content/BlockContent.vue'
import TableMenu from '../Components/UI/Table/TableMenu.vue'
import CardContent from '../Components/UI/Content/CardContent.vue'
import DataTable from '../Components/UI/Table/DataTable.vue'
import mixinComponent from '../Mixins/mixinComponent'
import { globalVariablesMixin } from '../Mixins/global'
import { isTheme } from '../Utils/isTheme'
import PageLayout from '../Components/UI/PageLayout.vue'

export default {
  components: {
    PageLayout,
    DataTable,
    CardContent,
    TableMenu,
    BlockContent,
    MainContainer,
  },
  mixins: [mixinComponent, globalVariablesMixin],
  data() {
    return {
      menu: 'demands-index',
      nbDemand: 0,
      loadField: false,
      selectedStatus: 0,
      createdAt: null,
      createdAtEnd: null,
      demandListRequest: null,
    }
  },

  watch: {
    selectedStatus(val) {
      if (val != null) {
        this.cancelPendingRequest()
        this.$refs.listeAccord.renderDataTable()
      }
    },
  },
  computed: {
    showFiltersButton() {
      return user.isBusinessMan && this.conf.theme_dir != 'ciscar'
    },
    submenuLabels() {
      return [
        { id: 0, name: this.$t('simulation.list.status.ALL') },
        {
          id: 1,
          name: this.$t('home.dashboardSimulation.status.waiting'),
          visible: this.conf.theme_dir == 'solufinance',
        },
        { id: 2, name: this.$t('home.dashboardSimulation.status.study') },
        { id: 3, name: this.$t('home.dashboardSimulation.status.accepted') },
        {
          id: 4,
          name: this.$t('home.dashboardSimulation.status.refused'),
          visible: isTheme('solufinance', 'olinn', 'stelogy'),
        },
      ]
    },
    columns() {
      return [
        {
          name: 'simulationId',
          title: this.$t('simulation.list.table.labelNumber'),
          style: { className: 'col-align-center' },
          formatter: 'context',
          options: { renderType: 'simulation' },
          displayable: !isTheme('itl'),
        },
        {
          name: 'id',
          title: this.$t('demand.list.demandId'),
          style: { className: 'col-align-center' },
          displayable: isTheme('itl'),
        },
        {
          name: 'demandNumber',
          title: this.$t('demand.list.number'),
          style: { className: 'col-align-center' },
          displayable: !isTheme('itl'),
        },
        {
          name: 'createdAt',
          title: this.$t('demand.list.createdAt'),
          formatter: 'date',
          displayable: !isTheme('itl'),
        },
        {
          name: 'statusAt',
          title: this.$t('demand.list.statusAt'),
          formatter: 'date',
          displayable: isTheme('itl'),
        },
        {
          name: 'clientName',
          title: this.$t('demand.list.client'),
          formatter: 'entity',
          options: { renderId: 'clientId' },
        },
        {
          name: 'refinancerName',
          title: this.$t('demand.list.refinancer'),
          displayable: !isTheme('lbp') && (user.isBusinessMan || user.isAdmin),
          options: { renderId: 'refinancerId' },
          formatter: 'entity',
          position: isTheme('itl') ? 3 : 0,
        },
        {
          name: 'platformSalesmanName',
          title: this.$t('demand.list.platformSalesman'),
          options: { renderType: 'demand' },
          displayable: !isTheme('itl'),
        },
        {
          name: 'contractTypeName',
          title: this.$t('demand.list.contractType'),
          displayable: !isTheme('financia', 'itl'),
        },
        {
          name: 'createdByName',
          title: this.$t('demand.fields.createdBy.label'),
          displayable: isTheme('olinn'),
          style: { width: '10px;' },
        },
        {
          name: 'productTypeName',
          title: this.$t('demand.list.productName'),
          options: { renderType: 'demand' },
          displayable: !isTheme('itl'),
        },
        {
          name: 'financeAmount',
          title: this.$t('demand.list.amountDemand'),
          type: 'num-fmt',
          formatter: 'currency',
          position: isTheme('itl') ? 8 : 0,
        },
        {
          name: 'availableContracts',
          title: this.$t('demand.list.amountAvailable'),
          type: 'num-fmt',
          formatter: 'currency',
          displayable: !isTheme('itl'),
        },
        {
          name: 'financeDuration',
          title: this.$t('demand.list.rentDuration'),
          position: isTheme('itl') ? 4 : 0,
        },
        {
          name: 'status',
          title: this.$t('demand.list.status'),
          formatter: 'status',
          options: { renderType: 'demand' },
          position: isTheme('itl') ? 5 : 0,
        },
        {
          name: 'decisionMessage',
          title: this.$t('demand.list.message'),
          formatter: 'action',
          options: { renderType: 'comment' },
          position: isTheme('itl') ? 6 : 0,
        },
        {
          name: 'companySalesmanName',
          title: this.$t('demand.list.companySalesman'),
          displayable: isTheme('itl'),
          position: 7,
        },
        {
          name: 'decisionValidity',
          title: this.$t('demand.list.validity'),
          formatter: 'date',
          position: isTheme('itl') ? 9 : 0,
        },
      ]
    },
    searchParams() {
      const searchParams = new URLSearchParams()

      const statuses = this.getStatusesArray()
      statuses.forEach((status) => {
        searchParams.append('statuses[]', status)
      })

      if (this.createdAt) {
        searchParams.set('createdAt', this.createdAt)
      }
      if (this.createdAtEnd) {
        searchParams.set('createdAtEnd', this.createdAtEnd)
      }

      return searchParams
    },
  },

  methods: {
    cancelPendingRequest() {
      this.demandListRequest?.cancel()
      this.demandListRequest = null
    },
    setDateTable(createdAt, createdAtEnd) {
      this.cancelPendingRequest()
      this.createdAt = createdAt
      this.createdAtEnd = createdAtEnd
      this.$refs.listeAccord.renderDataTable()
    },
    updateFilterData(name, value) {
      this.cancelPendingRequest()
      this[name] = value
      this.$refs.listeAccord.renderDataTable()
    },
    setSelectedStatus(value) {
      value = parseInt(value)
      if (value !== this.selectedStatus) {
        this.selectedStatus = value
      }
    },
    setBuild(bool) {
      this.loadField = bool
    },
    async getDemand(callback, { page, limit, search, sort = [] }) {
      this.cancelPendingRequest()

      const searchParams = new URLSearchParams(this.searchParams.toString())
      searchParams.set('page', page)
      searchParams.set('limit', limit)

      for (let { field, order } of sort) {
        searchParams.set(`sort[${field}]`, order)
      }

      if (!!search) {
        searchParams.set('q', search)
      }

      const getJsonPromise = this.getJSON(`v2/demands?${searchParams.toString()}`)
      this.demandListRequest = getJsonPromise
      const { items: demands, total } = await getJsonPromise
      callback({ data: demands, recordsTotal: total, recordsFiltered: total })
    },
    getParsedDemandStatuses() {
      if (!this.conf || !this.conf.demandStatuses) return []
      if (typeof this.conf.demandStatuses === 'string') {
        return this.conf.demandStatuses.split('-')
      }
      if (Array.isArray(this.conf.demandStatuses)) {
        return [...this.conf.demandStatuses]
      }
      if (typeof this.conf.demandStatuses === 'object') {
        return Object.values(this.conf.demandStatuses)
      }
      return []
    },
    getStatusesArray() {
      let arrStatus = this.getParsedDemandStatuses()
      let statuses = []

      switch (this.selectedStatus) {
        case 1:
          let created = ['CLIENT_PROPOSAL', 'CREATED', 'CLIENT_ACCEPTED']
          statuses = arrStatus.filter((s) => {
            return created.includes(s)
          })
          break
        case 2:
          let study = [
            'STUDY',
            'REQUESTED',
            'DETAILLED_STUDY',
            'PREACCEPTED',
            'CLIENT_REQUEST',
            'TO_BE_COMPLETED',
            'VALIDATION_REQUEST',
          ]
          statuses = arrStatus.filter((s) => {
            return study.includes(s)
          })
          break
        case 3:
          let accepted = ['ACCEPTED', 'CONDITIONAL', 'ACCEPTED_FORCED', 'CHANGED']
          statuses = arrStatus.filter((s) => {
            return accepted.includes(s)
          })
          break
        case 4:
          statuses = ['REFUSED', 'NOT_ACCEPTED', 'DEFINITIVE_REFUSAL']
          break
        default:
          statuses = arrStatus
      }

      return statuses
    },
    setUrl() {
      let arrStatus = this.getParsedDemandStatuses()
      let status = arrStatus.join('-')
      switch (this.selectedStatus) {
        case 1:
          let created = ['CLIENT_PROPOSAL', 'CREATED', 'CLIENT_ACCEPTED']
          let statusCreated = arrStatus.filter((s) => {
            return created.includes(s)
          })
          status = statusCreated.join('-')
          break
        case 2:
          let study = [
            'STUDY',
            'REQUESTED',
            'DETAILLED_STUDY',
            'PREACCEPTED',
            'CLIENT_REQUEST',
            'TO_BE_COMPLETED',
            'VALIDATION_REQUEST',
          ]
          let statusStudy = arrStatus.filter((s) => {
            return study.includes(s)
          })
          status = statusStudy.join('-')
          break
        case 3:
          let accepted = ['ACCEPTED', 'CONDITIONAL', 'ACCEPTED_FORCED', 'CHANGED']
          let statusAccepted = arrStatus.filter((s) => {
            return accepted.includes(s)
          })
          status = statusAccepted.join('-')
          break
        case 4:
          status = 'REFUSED-NOT_ACCEPTED-DEFINITIVE_REFUSAL'
          break
        default:
          status = status
      }

      return status
    },
    async download() {
      this.toast(this.$t('home.export.generating'))

      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hours = date.getHours()
      var minutes = date.getMinutes()
      var seconds = date.getSeconds()

      let formatDate = year + '-' + month + '-' + day + '-' + hours + '-' + minutes + '-' + seconds

      const searchParams = new URLSearchParams(this.searchParams.toString())

      if (searchParams.has('statuses[]')) {
        searchParams.set('statuses', searchParams.getAll('statuses[]').join('-'))
      }

      await this.downloadFile(`demands/export?${searchParams.toString()}`, `Demand-${formatDate}.xlsx`)

      this.toast(this.$t('home.export.sucess'))
    },
  },

  mounted() {
    $('#liste tbody').on('click', 'tr i', (e) => {
      this.id = e.target.id
      this.deleteJSON('demands/' + this.id, {}).then(
        (json) => {
          this.$refs.listeAccord.renderDataTable()
        },
        (reason) => {
          alert(reason)
        },
      )
    })
  },
}
</script>

<template>
  <PageLayout menu="demands-index">
    <MainContainer title-t="menu.myDemands">
      <BlockContent>
        <TableMenu
          :status="selectedStatus"
          :show-filters-button="showFiltersButton"
          :submenu-labels="submenuLabels"
          endpoint="quotations"
          @download="download"
          @set-date="setDateTable"
          @set-selected-status="setSelectedStatus"
          @update-filter-data="updateFilterData"
        >
        </TableMenu>
        <CardContent>
          <DataTable
            ref="listeAccord"
            id="listeAccord"
            :columns="columns"
            :fetch="getDemand"
            :order="[{ dir: 'desc', name: 'createdAt' }]"
            :first-load="true"
            pagination-mode="server"
          >
          </DataTable>
        </CardContent>
      </BlockContent>
    </MainContainer>
  </PageLayout>
</template>
